export const SNIPPETS = [
  // Honest (9 secrets, high truthfulness)
  {
    id: 1,
    text: "The dockmaster’s on our payroll—whiskey shipments clear every Tuesday.",
    truthfulness: 85,
    patronType: "honest",
    category: "Smuggling",
  },
  {
    id: 2,
    text: "There’s a trapdoor in the cellar hiding a cash-filled safe.",
    truthfulness: 90,
    patronType: "honest",
    category: "Assets",
  },
  {
    id: 3,
    text: "The mayor’s aide passes bribes here for a casino deal every Sunday.",
    truthfulness: 80,
    patronType: "honest",
    category: "Corruption",
  },
  {
    id: 4,
    text: "The boss’s cousin skims profits, stashing cash in the piano.",
    truthfulness: 85,
    patronType: "honest",
    category: "Betrayal",
  },
  {
    id: 5,
    text: "The delivery truck’s hauling guns, not booze, this Thursday.",
    truthfulness: 80,
    patronType: "honest",
    category: "Smuggling",
  },
  {
    id: 6,
    text: "The don’s mistress runs a blackmail ring from the back room.",
    truthfulness: 75,
    patronType: "honest",
    category: "Corruption",
  },
  {
    id: 7,
    text: "A secret tunnel under the bar leads to the docks for smugglers.",
    truthfulness: 85,
    patronType: "honest",
    category: "Smuggling",
  },
  {
    id: 8,
    text: "The bookie’s ledger is hidden behind the bar’s mirror.",
    truthfulness: 80,
    patronType: "honest",
    category: "Assets",
  },
  {
    id: 9,
    text: "The rival gang’s boss meets his informant here every Monday.",
    truthfulness: 75,
    patronType: "honest",
    category: "Betrayal",
  },

  // Cop (9 secrets, mixed truthfulness)
  {
    id: 10,
    text: "The sax player’s signaling Fed raid plans with his solos.",
    truthfulness: 75,
    patronType: "cop",
    category: "Law Enforcement",
  },
  {
    id: 11,
    text: "The Feds plan to raid this joint next week—tip from a crooked cop.",
    truthfulness: 80,
    patronType: "cop",
    category: "Law Enforcement",
  },
  {
    id: 12,
    text: "The cops planted a snitch here—the guy with the red tie.",
    truthfulness: 70,
    patronType: "cop",
    category: "Law Enforcement",
  },
  {
    id: 13,
    text: "The jukebox is rigged to record conversations for the Feds.",
    truthfulness: 55,
    patronType: "cop",
    category: "Law Enforcement",
  },
  {
    id: 14,
    text: "A Fed agent’s posing as a regular, sketching the bar’s layout.",
    truthfulness: 65,
    patronType: "cop",
    category: "Law Enforcement",
  },
  {
    id: 15,
    text: "The cigarette girl’s hat hides a wire for the police.",
    truthfulness: 70,
    patronType: "cop",
    category: "Law Enforcement",
  },
  {
    id: 16,
    text: "The cops know about our dock shipments—raid’s set for Friday.",
    truthfulness: 75,
    patronType: "cop",
    category: "Law Enforcement",
  },
  {
    id: 17,
    text: "The don’s new driver is an undercover Fed, reporting daily.",
    truthfulness: 60,
    patronType: "cop",
    category: "Law Enforcement",
  },
  {
    id: 18,
    text: "The police chief’s taking bribes but still plans a crackdown.",
    truthfulness: 50,
    patronType: "cop",
    category: "Corruption",
  },

  // Rival (9 secrets, mixed truthfulness)
  {
    id: 19,
    text: "The rival gang’s planning a hit on our warehouse Friday midnight.",
    truthfulness: 70,
    patronType: "rival",
    category: "Betrayal",
  },
  {
    id: 20,
    text: "The cigarette girl’s a spy for the Irish mob, wiring tips.",
    truthfulness: 65,
    patronType: "rival",
    category: "Betrayal",
  },
  {
    id: 21,
    text: "The chef’s spiking drinks with laudanum to loosen tongues.",
    truthfulness: 60,
    patronType: "rival",
    category: "Sabotage",
  },
  {
    id: 22,
    text: "The rival gang’s mole is in our card game, cheating us blind.",
    truthfulness: 60,
    patronType: "rival",
    category: "Betrayal",
  },
  {
    id: 23,
    text: "I swapped the boss’s ledger with a fake—nobody’s noticed.",
    truthfulness: 40,
    patronType: "rival",
    category: "Sabotage",
  },
  {
    id: 24,
    text: "The bartender’s apron has bloodstains—nobody’s asking why.",
    truthfulness: 50,
    patronType: "rival",
    category: "Suspicion",
  },
  {
    id: 25,
    text: "The rival boss bribed the doorman to let in their hitman.",
    truthfulness: 65,
    patronType: "rival",
    category: "Betrayal",
  },
  {
    id: 26,
    text: "The rival gang’s planting fake evidence to frame the boss.",
    truthfulness: 55,
    patronType: "rival",
    category: "Sabotage",
  },
  {
    id: 27,
    text: "The bar’s whiskey’s been watered down by a rival supplier.",
    truthfulness: 60,
    patronType: "rival",
    category: "Sabotage",
  },

  // Drunk (9 secrets, low truthfulness)
  {
    id: 28,
    text: "I saw the Virgin Mary in my whiskey glass—she told me to confess!",
    truthfulness: 10,
    patronType: "drunk",
    category: "Nonsense",
  },
  {
    id: 29,
    text: "I sold my soul for a perfect martini recipe.",
    truthfulness: 15,
    patronType: "drunk",
    category: "Nonsense",
  },
  {
    id: 30,
    text: "The walls whispered the boss’s real name last night.",
    truthfulness: 20,
    patronType: "drunk",
    category: "Nonsense",
  },
  {
    id: 31,
    text: "The piano’s haunted—plays itself when the moon’s full.",
    truthfulness: 25,
    patronType: "drunk",
    category: "Nonsense",
  },
  {
    id: 32,
    text: "I swapped the mayor’s cigar with dynamite—boom!",
    truthfulness: 30,
    patronType: "drunk",
    category: "Nonsense",
  },
  {
    id: 33,
    text: "The bar’s built on a cursed Indian burial ground.",
    truthfulness: 15,
    patronType: "drunk",
    category: "Nonsense",
  },
  {
    id: 34,
    text: "I lost my ear in a poker game—won it back!",
    truthfulness: 20,
    patronType: "drunk",
    category: "Nonsense",
  },
  {
    id: 35,
    text: "The whiskey’s talking to me, says it’s from 1899.",
    truthfulness: 25,
    patronType: "drunk",
    category: "Nonsense",
  },
  {
    id: 36,
    text: "The boss is a time traveler from 3000 AD!",
    truthfulness: 10,
    patronType: "drunk",
    category: "Nonsense",
  },
];
